
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M1.6 3.785c.885 0 1.6.845 1.6 1.892 0 1.046-.715 1.892-1.6 1.892-.885 0-1.6-.846-1.6-1.892C0 4.63.715 3.785 1.6 3.785M1.6 11.354c.885 0 1.6.845 1.6 1.892 0 1.046-.715 1.892-1.6 1.892-.885 0-1.6-.846-1.6-1.892 0-1.047.715-1.892 1.6-1.892M1.6 18.923c.885 0 1.6.845 1.6 1.892 0 1.046-.715 1.892-1.6 1.892-.885 0-1.6-.846-1.6-1.892 0-1.047.715-1.892 1.6-1.892M6.4 0C7.285 0 8 .846 8 1.892c0 1.047-.715 1.893-1.6 1.893-.885 0-1.6-.846-1.6-1.893C4.8.846 5.515 0 6.4 0M6.4 7.569c.885 0 1.6.846 1.6 1.892 0 1.047-.715 1.893-1.6 1.893-.885 0-1.6-.846-1.6-1.893 0-1.046.715-1.892 1.6-1.892M6.4 15.138c.885 0 1.6.846 1.6 1.892 0 1.047-.715 1.893-1.6 1.893-.885 0-1.6-.846-1.6-1.893 0-1.046.715-1.892 1.6-1.892"}})])])
          )
        }
      }
    